module.exports = __webpack_public_path__ + "img/placeholder.0fbb44d5.jpg";